import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BreadcrumbComponent } from 'src/app/components/shared/breadcrumb/breadcrumb.component';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-app-setting',
    imports: [
    CommonModule,
    BreadcrumbComponent,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatSlideToggleModule
  ],
  templateUrl: './app-setting.page.html',
  styleUrl: './app-setting.page.scss'
})
export class AppSettingPage {

   // 🔹 UI state variables
  selectedLanguage: string = 'en';
  notificationsSetting: string = 'Show';
  darkMode: 'enabled' | 'disabled' = 'disabled';

  loading = false;
  error: string = '';
  success: string = '';

  settings: any = null;

  constructor(private settingsService: SettingsService) {}

  ngOnInit(): void {
    this.loadSettings();
  }

  /** 🔹 Load settings from backend */
  loadSettings(): void {
    this.loading = true;
    this.error = '';

    this.settingsService.getSettings().subscribe({
      next: (res) => {
        this.settings = res;
        this.selectedLanguage = res.language || 'en';
        this.notificationsSetting = res.notifications ? 'Show' : 'Hide';
        this.darkMode = res.isDarkMode ? 'enabled' : 'disabled';

        // Apply dark mode if enabled
        document.body.classList.toggle('dark-theme', res.isDarkMode);
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching settings:', err);
        this.error = 'Failed to load settings';
        this.loading = false;
      }
    });
  }

  /** 🔹 Toggle notifications */
  onNotificationToggle(event: any): void {
    this.notificationsSetting = event.checked ? 'Show' : 'Hide';
  }

  /** 🔹 Toggle dark mode */
  toggleDarkMode(isEnabled: boolean): void {
    this.darkMode = isEnabled ? 'enabled' : 'disabled';
    document.body.classList.toggle('dark-theme', isEnabled);
  }

  /** 🔹 Save settings */
  saveSettings(): void {
    this.loading = true;
    this.error = '';
    this.success = '';

    const updatedSettings = {
      language: this.selectedLanguage,
      notifications: this.notificationsSetting === 'Show',
      isDarkMode: this.darkMode === 'enabled'
    };

    this.settingsService.updateSettings(updatedSettings).subscribe({
      next: (updated) => {
        this.settings = updated;
        this.success = 'Settings updated successfully!';
        this.loading = false;
      },
      error: (err) => {
        console.error('Error updating settings:', err);
        this.error = 'Failed to update settings';
        this.loading = false;
      }
    });
  }

  /** 🔹 Reset settings to default */
  resetSettings(): void {
    if (!confirm('Are you sure you want to reset your settings?')) return;

    this.loading = true;
    this.error = '';
    this.success = '';

    this.settingsService.deleteSettings().subscribe({
      next: () => {
        this.settings = null;
        this.selectedLanguage = 'en';
        this.notificationsSetting = 'Show';
        this.darkMode = 'disabled';
        document.body.classList.remove('dark-theme');

        this.success = 'Settings reset to default successfully.';
        this.loading = false;
      },
      error: (err) => {
        console.error('Error resetting settings:', err);
        this.error = 'Failed to reset settings';
        this.loading = false;
      }
    });
  }

}
